export const formatToPercentage = (num: number) => {
    return Number(num/100).toLocaleString(undefined,{style: 'percent'})
  };